module.exports = __webpack_public_path__ + "img/icon-seasons-folder.85e7ae95.svg";